import BossModel from "@/models/BossModel";

export default class Changelog extends BossModel {

    static apiUrl = 'changelog';

    static entity = 'Changelogs';

    static fields() {
		return {
			id: this.number(null).nullable(),
            version: this.attr(null),
            content: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
		}
	}
}
